/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import {
  CButton,
  CSpinner,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CListGroup,
  CListGroupItem,
  CRow,
  CCol,
  CModalTitle,
  CSelect,
  CInput
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import Uploader from "../../Uploader/uploader";

class DashboardAlunoOmniConfigure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      json: props.json || [],
      indexChangingImage: null,
      loading: true,
      disciplines: [],
      series: [],
      urls: []
    };
  }

  componentDidMount() {
    Promise.all([
      axios.get(`${URL.api}classification/discipline/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }),
      axios.get(`${URL.api}classification/serie/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
    ]).then(
      ([disciplineGet, serieGet]) => {
        this.setState({
          loading: false,
          disciplines: disciplineGet.data.data.map(item => ({
            id: item.id,
            name: item.name
          })),
          series: serieGet.data.data.map(item => ({
            id: item.id,
            name: item.name
          }))
        });
      },
      () => {
        this.error("Falha ao carregar dados");
      }
    );

    const urls = this.props.json.map(item => item.url || "");
    this.setState({ urls });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  onConfirm() {
    if (
      this.state.json.find(
        item => !item.image || !item.serie_id || !item.discipline_id
      )
    ) {
      toastr.error("Falha", "Preencha todos os campos");
      return;
    }

    this.props.onChange(this.state.json);
    this.props.onClose();
  }

  done(index, uploads) {
    this.setState(state => {
      const newJson = [...state.json];
      newJson[index].image = URL.img + uploads[0];

      return {
        json: newJson,
        indexChangingImage: null
      };
    });
  }

  changeDiscipline(index, discipline) {
    this.setState(state => {
      const newJson = [...state.json];
      newJson[index].discipline_id = discipline;

      return {
        json: newJson
      };
    });
  }

  changeSerie(index, serie) {
    this.setState(state => {
      const newJson = [...state.json];
      newJson[index].serie_id = serie;

      return {
        json: newJson
      };
    });
  }

  changeURL(index, url) {
    this.setState(state => {
      const newJson = [...state.json];
      newJson[index].url = url;

      const urlsCopy = [...state.urls];
      urlsCopy[index] = url;

      return {
        json: newJson,
        urls: urlsCopy
      };
    });
  }

  deleteRow(index) {
    this.setState(state => {
      const newJson = [...state.json];
      newJson.splice(index, 1);

      return {
        json: newJson,
        indexChangingImage:
          state.indexChangingImage === index ? null : state.indexChangingImage
      };
    });
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        closeOnBackdrop={false}
        onClose={() => this.props.onClose()}
      >
        <CModalHeader closeButton>
          <CModalTitle>Configurar Dashboard Omni</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ overflow: "auto" }}>
          {this.state.loading ? (
            <div className="h-100 my-5 d-flex justify-content-center align-items-center">
              <CSpinner color="primary" />
            </div>
          ) : (
            <CListGroup>
              {this.state.json.map((item, index) => (
                <CListGroupItem
                  key={index + item.discipline_id + item.serie_id + item.image}
                >
                  <CRow>
                    <CCol>
                      {index === this.state.indexChangingImage ? (
                        <Uploader
                          type="lo"
                          maxFiles={1}
                          acceptedFileTypes={["image/*"]}
                          allowMultiple
                          labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                          done={uploads => this.done(index, uploads)}
                        />
                      ) : (
                        <div className="d-flex align-items-center">
                          {item.image && (
                            <img
                              src={item.image}
                              style={{ maxHeight: "60px" }}
                              className="mr-3"
                            />
                          )}
                          <CButton
                            color="primary"
                            onClick={() =>
                              this.setState({ indexChangingImage: index })
                            }
                          >
                            {item.image ? "Alterar" : "Adicionar"} Imagem
                          </CButton>
                        </div>
                      )}
                    </CCol>
                    <CCol className="d-flex align-items-center">
                      <CSelect
                        value={item.discipline_id}
                        onChange={e =>
                          this.changeDiscipline(index, e.target.value)
                        }
                      >
                        <option value="">Selecione uma disciplina</option>
                        {this.state.disciplines.map(discipline => (
                          <option key={discipline.id} value={discipline.id}>
                            {discipline.name}
                          </option>
                        ))}
                      </CSelect>
                    </CCol>
                    <CCol className="d-flex align-items-center">
                      <CInput
                        value={this.state.urls[index]}
                        onChange={e => this.changeURL(index, e.target.value)}
                        placeholder="URL"
                        autoComplete="off1"
                      />
                    </CCol>
                    <CCol className="d-flex align-items-center">
                      <CSelect
                        value={item.serie_id}
                        onChange={e => this.changeSerie(index, e.target.value)}
                      >
                        <option value="">Selecione uma série</option>
                        {this.state.series.map(serie => (
                          <option key={serie.id} value={serie.id}>
                            {serie.name}
                          </option>
                        ))}
                      </CSelect>
                      <CButton
                        color="danger"
                        className="ml-2"
                        onClick={() => this.deleteRow(index)}
                      >
                        <i className="fa fa-trash" />
                      </CButton>
                    </CCol>
                  </CRow>
                </CListGroupItem>
              ))}
              <CListGroupItem
                action
                onClick={() =>
                  this.setState(state => ({
                    json: [
                      ...state.json,
                      { image: null, discipline_id: null, serie_id: null }
                    ]
                  }))
                }
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  fontWeight: "bold"
                }}
              >
                Adicionar livro
              </CListGroupItem>
            </CListGroup>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={() => this.onConfirm()}>
            Confirmar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardAlunoOmniConfigure);
